<template>
  <div class="IndexTop10">
	  <div v-if="screenWidth>1200" class="desktop-top10" >
			<section class="kv">
				<div class="kv-scroll page-scroll-kv" href=".top10"></div>
			</section>
			<section class="top10">
				<img src="../assets/images/d-index-top10-title.png" alt="" class="top-title">
			<!--item templete using v-for when read json data -->
				<div class="top10-container">
					<div v-for="(product,index) in currentVoteData" class="product-item" :key="product.id" v-bind:style="{backgroundImage: 'url(' + setImageUrl(product.image) + ')'}">
						<div class="class">
							<h2 class="class-name">{{ matchClass(index+1,'chiName') }}</h2>
							<p class="class-name-eng">{{ matchClass(index+1,'engName') }}</p>
						</div>
						<div class="pd-cover">
							<h3 class="pd-cover-class-name">{{ matchClass(index+1) }}</h3>
							<div class="pd-content">
								<p class="pd-brand-name">{{product.brand}}</p>
								<p class="pd-pd-name">{{product.product}}</p>
							</div>
							<router-link class="pd-btn-vote" :to="{ path: '/Popular/result'}">看更多</router-link>
							<!-- <router-link class="pd-btn-vote" :to="{ path: '/vote/'+matchClass(index+1,'engName')}">我要投票</router-link> -->
						</div>
					</div> 
				</div>
				<div class="top10-btn-container">
					<router-link class="common-btn" to="/Popular/info">活動辦法<img src="../assets/images/d-btn-arrow.png" alt="" class="btn-arrow"></router-link>
					<!-- <router-link class="common-btn" to="/vote/info">活動辦法<img src="../assets/images/d-btn-arrow.png" alt="" class="btn-arrow"></router-link> -->
					<!-- <router-link class="common-btn" to="/vote/tovote"><img src="../assets/images/d-btn-cosmo-icon.png" class="cosmo-logo" alt=""> 我要投票<img src="../assets/images/d-btn-arrow.png" alt="" class="btn-arrow"></router-link> -->
				</div>
			</section>
		</div>
	    <div v-else class="mobile-top10" >
			<section class="kv">
				<div class="kv-scroll page-scroll-kv" href=".top10"></div>
			</section>
			<section class="top10">
				<img src="../assets/images/m-index-top10-title.png" alt="" class="top-title">
					<!--item templete using v-for when read json data -->
				<div class="top10-container">
					<div v-for="(product,index) in currentVoteData" :key="product.id" class="product-item" v-bind:style="{backgroundImage: 'url(' + setImageUrl(product.image) + ')'}" v-bind:class="{ right: ((index+1)%2==0), left: ((index+1)%2!=0) }">
						<div class="product-item-cover" ></div> 
						<div class="class-content">
							<h2 class="class-name">{{ matchClass(index+1,'chiName') }}</h2>
							<p class="class-name-eng">{{ matchClass(index+1,'engName') }}</p>
						</div>
						<div class="pd-content">
							<p class="pd-brand-name">{{product.brand}}</p>
							<p class="pd-pd-name">{{product.product}}</p>
						</div>
						<router-link class="pd-btn-vote" :to="{ path: '/Popular/result'}"></router-link>
						<!-- <router-link class="pd-btn-vote" :to="{ path: '/vote/'+matchClass(index+1,'engName')}"></router-link> -->
					</div>
				</div>
				<div class="top10-btn-container">
					<router-link class="common-btn" to="/Popular/info">活動辦法<img src="../assets/images/d-btn-arrow.png" alt="" class="btn-arrow"></router-link>
					<!-- <router-link class="common-btn" to="/vote/info">活動辦法<img src="../assets/images/m-btn-arrow.png" alt="" class="btn-arrow"></router-link> -->
					<!-- <router-link class="common-btn" to="/vote/tovote"><img src="../assets/images/m-btn-cosmo-icon.png" class="cosmo-logo" alt=""> 我要投票<img src="../assets/images/m-btn-arrow.png" alt="" class="btn-arrow"></router-link> -->
				</div>
			</section>
		</div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'IndexTop10',
  props:{
	  cosmoUrl: String,
	  allProductData: {},
	  allProcuctClass: {},
	  screenWidth: Number
  },
  data () {
    return {
		currentVote:{},
		currentVoteData:[],
		scrollToInfo: 'eventInfo'
	}
  },
  watch:{
	  allProductData(val){
		  let self = this 
		  self.allProductData = val 
		//   console.log("getAllPd-----")
		  self.getTop10Data()
	  }
  },
  created(){
	let self = this 


	self.getTop10Data()
  },
  mounted(){

	},
	computed:{
		filterProducts:function(){
			debugger
			// console.log(this.currentVote)
	
		}
	},
	methods:{
		getTop10Data: function(){
			let self = this
			// console.log("props:"+self.cosmoUrl)
			// console.log(self.allProductData)

			// console.log("top10-----")
			axios.get(self.cosmoUrl+'route.php?r=vote')
			.then((resp)=>{
				self.currentVote = resp.data
				// console.log(self.currentVote)
				let obj = self.allProductData;
				let ids = self.currentVote;
				Object.keys(ids).forEach((key)=>{      
					self.currentVoteData.push(obj[key][ids[key].id]);            
				})      
				// console.log(self.currentVoteData)
			})
			.catch((err) => {
				console.log(err)
			})
		},
		matchClass: function(classNum='1',item='both'){
			let self = this 
			if(item == 'chiName')
				return self.allProcuctClass[classNum].chiName 
			else if(item == 'engName')
				return self.allProcuctClass[classNum].engName
			else 
				return self.allProcuctClass[classNum].chiName +' '+ self.allProcuctClass[classNum].engName
		},
		setImageUrl: function(productImage){
			let self = this 
			return self.cosmoUrl+'images/'+productImage
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
$main-color: #f21290
.desktop-top10
	.top-title 
		margin: 0 auto 25px
	.top10-container
		display: flex
		flex-direction: row 
		flex-wrap: wrap
		width: calc(296px*4)
		margin: 0 auto
	.product-item
		width: 296px
		height: 296px
		position: relative
		background-position: 50% 50%
		background-size: 100%
		background-repeat: no-repeat
		&:hover 
			>.pd-cover 
				opacity: 1
				visibility: visible

		>.class
			position: relative
			width: 100%
			height: 100%
			background-image: url('../assets/images/d-index-pd-bg.png')
			background-repeat: no-repeat 
			background-size: 66%
			background-position: 0% 100%
			z-index: 2
			>.class-name 
				font-size: 20px
				font-weight: bold
				line-height: 1.0
				color: #ffffff
				position: absolute
				bottom: 15%
				left: 5%
				&-eng 
					color: #ffffff
					font-size: 14px
					font-weight: 300
					line-height: 1.43
					text-align: left
					bottom: 5%
					left: 5%
					position: absolute
		>.pd-cover 
			width: 100%
			height: 100%
			background-image: url('../assets/images/pd-cover.png')
			background-position: 50% 50%
			background-size: cover
			position: absolute
			top: 0
			left: 0
			opacity: 0
			visibility: hidden
			transition: opacity .35s, visibility .35s, height .35s
			z-index: 3
			display: flex
			flex-direction: column
			// justify-content: space-evenly
			justify-content: center
			align-items: center
			>.pd-cover-class-name
				display: inline-block
				text-align: center
				font-size: 18px
				line-height: 1.25
				color: $main-color 
				font-weight: bold
				position: relative
				text-align: center
				&:after
					content: ''
					position: absolute
					bottom: -12px
					width: 70%
					height: 1px
					background-color: $main-color
					left: 15%
			>.pd-content
				margin: 25px auto
				>.pd-brand-name,
				>.pd-pd-name
					color: #fff
					font-size: 18px
					font-weight: 500
					line-height: 1.33
					text-align: center
					
			>.pd-btn-vote
				background-color: $main-color
				width: 120px
				height: 35px
				text-align: center
				line-height: 35px
				color: #fff
				cursor: pointer
	.top10-btn-container
		margin: 0 auto
		// display: flex
		// flex-direction: row
		// width: 800px
		// justify-content: space-between
		margin-top: 110px
		width: 386px

	//common element
	.common-btn
		width: 386px
		height: 60px
		background-image: url(../assets/images/d-btn-templete.jpg)
		background-position: center center 
		background-repeat: no-repeat 
		background-size: cover
		position: relative
		text-align: center
		font-size: 24px
		font-weight: bold
		line-height: 60px
		letter-spacing: 1.8px
		text-align: center
		color: #ffffff
		&:hover 
			color: #fff
			.btn-arrow 
				right: 22%
		.cosmo-logo
			position: absolute
			left: 25%
			top: 16%
		.btn-arrow 
			position: absolute
			top: 6%
			right: 25%
			transition: right .2s ease-in-out



.mobile-top10
	.kv 
		height: 1170px
	.top10-container
		padding-bottom: 98px
	.top-title 
		margin: 0 auto
		margin-bottom: 30px
	.product-item
		width: 100%
		max-width: 750px
		margin: 0 auto
		height: 620px
		background-repeat: no-repeat
		background-size: contain
		background-color: #fff 
		background-position: 50% 50%
		margin-bottom: 40px
		position: relative
		>.class-content
			position: absolute
			top: 8%
			>.class-name
				font-size: 50px
				font-weight: 400
				line-height: 1.2
				color: #fff
				&-eng
					color: #fff
					font-size: 32px
					font-weight: 300
					line-height: 1.22
		>.pd-content
			bottom: 5%
			width: 330px
			position: absolute
			font-size: 36px
			font-weight: 300
			line-height: 1.28
			color: #ffffff
			text-shadow: 0px 0px 12px #222
			font-weight: 400
		>.pd-btn-vote
			width: 397px
			height: 69px
			background-repeat: no-repeat
			background-size: 100%
			background-position: 50% 50%
			position: absolute
			bottom: -20px
			// 區分左右邊樣式
		&.left 
			>.class-content
				left: 3.5%
				>.class-name-eng
					text-align: left
			>.pd-content
				text-align: left
				left: 3.5%
			>.product-item-cover
				background-image: url("../assets/images/pd-temp-bg-left.png")
				background-repeat: no-repeat
				width: 100%
				height: 100%
				background-size: 100%
			>.pd-btn-vote
				background-image: url('../assets/images/pd-temp-brn-right.png')
				right: 0
		&.right
			>.class-content
				right: 3.5%
				>.class-name-eng
					text-align: right
			>.pd-content
				text-align: right
				right: 3.5%
			>.product-item-cover
				background-image: url("../assets/images/pd-temp-bg-right.png")
				background-repeat: no-repeat
				width: 100%
				height: 100%
				background-size: 100%
			>.pd-btn-vote
				background-image: url('../assets/images/pd-temp-brn-left.png')
				left: 0

	.common-btn
		width: 552px
		height: 100px
		background-image: url(../assets/images/m-btn-templete.jpg)
		background-position: center center 
		background-repeat: no-repeat 
		background-size: cover
		position: relative
		text-align: center
		font-size: 40px
		font-weight: bold
		line-height: 100px
		letter-spacing: 3px
		text-align: center
		color: #ffffff
		margin: 0 auto
		margin-bottom: 20px
		&:hover 
			color: #fff
			.btn-arrow 
				right: 22%
		.cosmo-logo
			position: absolute
			left: 20%
			top: 25%
		.btn-arrow 
			position: absolute
			top: 15%
			right: 25%
			transition: all .2s ease-in-out

.mobile-top10 
	.product-item.left,
	.product-item.right
		> .pd-content
			>.pd-brand-name
				font-size: 28px	

</style>



// WEBPACK FOOTER //
// IndexTop10.vue?281298a1